import Config from 'react-native-config';

export const IS_SERVICE_EXPANSION_ENABLED = Config.LOCATION_SERVICE_EXPANSION_ENABLED === 'enabled';

export enum ENDPOINT_NAMES {
  DIRECTIONS_URL = 'directionsUrl',
  GEOCODE_URL = 'geocodeUrl',
  LOCATIONS = 'locations',
  MATRIX_URL = 'matrixUrl',
  PLACE_PREDICTIONS_URL = 'placePredictionsUrl'
}

export const LOCATION_URLS: Record<ENDPOINT_NAMES, string> = {
  directionsUrl: '/google/directions',
  geocodeUrl: '/google/geocode',
  locations: '/locations',
  matrixUrl: '/google/distance/matrix',
  placePredictionsUrl: '/google/place/predictions'
};
